import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Checkbox,
  CheckboxVisibility,
  DatePicker,
  DayOfWeek,
  DefaultButton,
  defaultDatePickerStrings,
  addDays,
  IColumn,
  Link,
  Modal,
  PrimaryButton,
  MessageBarType,
  MessageBar,
} from '@fluentui/react';
import { IObjectWithKey, Selection } from '@fluentui/react/lib/DetailsList';
import * as Api from '../../../api/src';
import ModalHeader from '../../../control/modalHeader';
import { NoDataFound } from '../../../control/noDataFound';
import Paging from '../../../control/paging';
import { commonfn } from '../../../common/commonfn';
import Moment from 'moment';
import { TeuDetailsList } from '../../../control/detailList';
export interface ModalAddModuleProps {
  IsOpen: boolean;
  onCloseModal: () => void;
  onSaveClick?: () => void;
  MatrixItemId: number;
  ProductTypeId: number;
  Modules: Api.MatrixItemModule[];
}
const MatrixApi = new Api.MatrixsApi();
const MatrixItemsApi = new Api.MatrixItemsApi();
let _selectionModules: Selection | undefined = new Selection();
const ModalAddModule = ({
  IsOpen,
  onCloseModal,
  onSaveClick,
  MatrixItemId,
  ProductTypeId,
  Modules,
}: ModalAddModuleProps) => {
  const { t } = useTranslation();
  const [isShow, SetIsShow] = React.useState(false);
  const [itemChecked, setitemChecked] = React.useState<any[]>();
  const [showModuleError, SetShowModuleError] = React.useState(false);

  const [listModules, setListModules] = React.useState<
    (Api.MatrixItemModuleCanBeAdd & { DeadLine: string; checked: boolean; disable: boolean; datePick: boolean })[]
  >([]);
  const _columnsModule = [
    {
      key: 'Module',
      name: t('ModuleName'),
      fieldName: 'Name',
      className: 'flex-center',
      isResizable: true,
      minWidth: 250,
      onRender: (item: Api.Module) => {
        return item.Name;
      },
    },
    {
      key: 'Component',
      name: t('Component'),
      className: 'flex-center',
      minWidth: 150,
      onRender: (item: Api.MatrixItemModuleCanBeAdd) => {
        return item.Component?.Name ?? '-';
      },
    },
    {
      key: 'Deadline',
      name: t('Deadline'),
      className: 'flex-center',
      minWidth: 150,
      onRender: (item: Api.MatrixItemModuleCanBeAdd) => {
        return (
          <DatePicker
            //firstDayOfWeek={DayOfWeek.Sunday}
            showWeekNumbers={true}
            firstWeekOfYear={1}
            showMonthPickerAsOverlay={true}
            //minDate={addDays(new Date(), 1)}
            value={item.DeadlineDate ? Moment(item.DeadlineDate).toDate() : undefined}
            placeholder="dd/mm/yyyy"
            formatDate={(date?: Date): string => {
              return Moment(date).format('DD/MM/yyyy');
            }}
            onSelectDate={(date: Date | null | undefined) => {
              listModules?.forEach((element) => {
                if (element.Id == item.Id) {
                  element.datePick = true;
                  element.DefaultDeadlineDay = Moment(date).diff(Moment().startOf('d'), 'd');
                  element.DeadlineDate = date?.toISOString() || null;
                }
              });
              setListModules(listModules);
            }}
            strings={defaultDatePickerStrings}
          />
        );
      },
    },
    {
      key: 'Action',
      name: '',
      className: 'flex-center',
      onRender: (item, index) => {
        if (item.DefaultDeadlineDay)
          return (
            <Link
              onClick={() => {
                if (item.DefaultDeadlineDay) {
                  listModules?.forEach((element) => {
                    element.DefaultDeadlineDay = item.DefaultDeadlineDay;
                  });
                  setListModules([...(listModules || [])]);
                }
              }}
            >
              {t('ApplyForAll')}
            </Link>
          );
        else return '';
      },
    },
  ] as IColumn[];
  React.useEffect(() => {
    // creating items to display
    const itemsToDisplay: IObjectWithKey[] = [];
    // _selectionModules = new Selection();
    SetIsShow(IsOpen);
    if (IsOpen) {
      getModules();
    }
  }, [IsOpen]);

  const getModules = async () => {
    let data = (await MatrixItemsApi.apiMatrixItemsAllModuleAndAddedModuleByMatrixItemMatrixItemIdGet(MatrixItemId))
      .data;
    const modules =
      (data.Data as (Api.MatrixItemModuleCanBeAdd & {
        DeadLine: string;
        checked: boolean;
        disable: boolean;
        datePick: boolean;
      })[]) || [];
    modules?.forEach((o) => {
      o.checked = o.IsAdded || false;
      if (o.MatrixItemModule) {
        o.disable = o.MatrixItemModule.IsApproved || false;
        if (o.MatrixItemModule.Deadline) {
          o.DefaultDeadlineDay = Moment(o.MatrixItemModule.Deadline).diff(Moment(), 'd') - 1;
        }
      }
    });
    setListModules(modules);
  };
  const getTitle = (): string => {
    return t('AddRemoveModules');
  };
  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  const validateFormData = () => {
    let pass = true;
    if (_selectionModules) {
      const item = _selectionModules.getSelection();
      if (item.length) {
        pass = true;
      } else {
        pass = false;
      }
    }
    return pass;
  };
  const onSave = async () => {
    /* if (!validateFormData()) {
            SetShowModuleError(true);
            return;
        } */
    let objPost: Api.AddRemoveModuleMatrixItemCommand = {};
    let tmp: Api.ModuleIdAndDeadline[] = [];
    listModules.forEach((item) => {
      if (item.checked) {
        tmp.push(
          {
            ModuleId: item.Id,
            Deadline: item.DeadlineDate,
          }, //((item.DefaultDeadlineDay || item.datePick) ? Moment().add(item.DefaultDeadlineDay, 'd').toDate().toISOString() : null) }
        );
        objPost.ChooseModules = tmp;
      }
    });
    if (!objPost.ChooseModules?.length) {
      SetShowModuleError(true);
      return;
    }
    MatrixItemsApi.apiMatrixItemsMatrixItemIdAddRemoveModulePatch(MatrixItemId, objPost).then(() => {
      if (onSaveClick) {
        onSaveClick();
      }
    });
    onCloseModal();
    SetIsShow(false);
  };
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={getTitle()}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content'} style={{ width: 800 }}>
        {showModuleError && (
          <MessageBar messageBarType={MessageBarType.error} isMultiline={false} dismissButtonAriaLabel="Close">
            {t('PleaseSelectModule')}
          </MessageBar>
        )}
        <div className="ms-Grid-row">
          <TeuDetailsList
            props={{
              styles: { root: { minHeight: 600 } },
              items: listModules,
              columns: _columnsModule,
              compact: true,
              checkboxVisibility: CheckboxVisibility.always,
            }}
            // itemChecked={itemChecked ||[]}
          />

          <NoDataFound isShow={(listModules?.length || 0) === 0}></NoDataFound>
        </div>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          className={'margin-left-10'}
          onClick={() => {
            onClose();
          }}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          disabled={false}
          onClick={() => {
            onSave();
          }}
        >
          {t('Save')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModalAddModule;
